import React from "react";
import CodeEditorMock from "./CodeEditorMock";

const IndexJSPanel = () => {
  return (
    <div className="indexjspanel">
      <div className="file-info">
        <div className="cell file-name">
          <i class="fa-brands fa-js"></i>
          index.js
          <i class="fa-solid fa-x"></i>
        </div>
      </div>
      <div className="panel-content">
        <CodeEditorMock>
          <span class="const-color">const</span>{" "}
          <span class="variable-color">mert</span> = {"{"}
          <br />
          &nbsp;&nbsp;<span class="variable-color">location</span>:{" "}
          <span className="string-color">"Rotterdam, NL"</span>,
          <br />
          &nbsp;&nbsp;<span class="variable-color">profession</span>:
          <span className="string-color">"Full-Stack Developer"</span>,
          <br />
          &nbsp;&nbsp;<span class="variable-color">likes</span>:{" "}
          <span className="bracket">{"["}</span>
          <span className="string-color">
            "React", "Node.js", "SQL", "building stuff that nobody asked for"
          </span>
          <span className="bracket">{"]"}</span>,
          <br />
          &nbsp;&nbsp;<span class="variable-color">hobbies</span>:{" "}
          <span className="bracket">{"["}</span>{" "}
          <span className="string-color">
            "sailing", "gaming", "long walks", "debugging at 2AM"
          </span>
          <span className="bracket">{"]"}</span>,
          <br />
          &nbsp;&nbsp;<span class="variable-color">formerLife</span>:{" "}
          <span className="string-color">
            "licensed sailor & childhood sea warrior :D"
          </span>
          ,
          <br />
          &nbsp;&nbsp;<span class="variable-color">currentMood</span>:{" "}
          <span className="string-color">"let's ship it 🚀"</span>,
          <br />
          &nbsp;&nbsp;<span class="variable-color">lovesCoffe</span>:{" "}
          <span className="true-color-text">true</span>,
          <br />
          &nbsp;&nbsp;<span class="variable-color">hatesLinkedInBS</span>:{" "}
          <span className="true-color-text">true</span>
          <br />
          {"};"}
          <br />
          <br />
          <span class="const-color">const</span>{" "}
          <span class="function-color">buildCoolStuff</span> = () =&gt; {"{"}
          <br />
          &nbsp;&nbsp;<span class="const-color">const</span>{" "}
          <span class="variable-color">idea</span> ={" "}
          <span className="string-color">"something weird but useful"</span>;
          <br />
          &nbsp;&nbsp;<span class="const-color">const</span>{" "}
          <span class="variable-color">techStack</span> ={" "}
          <span className="string-color">
            {" "}
            <span className="bracket">{"["}</span>
            "Next.js", "Raspberry Pi", "CSS"{" "}
            <span className="bracket">{"]"}</span>
          </span>
          ;
          <br />
          &nbsp;&nbsp;<span class="variable-color">mert</span>.energy++;
          <br />
          &nbsp;&nbsp;<span className="return-color">return</span>{" "}
          <span class="variable-color">idea</span> +
          <span className="string-color"> " built with love 💜"</span>;
          <br />
          {"};"}
          <br />
          <br />
          <span class="function-color">buildCoolStuff</span>();
        </CodeEditorMock>
      </div>
    </div>
  );
};

export default IndexJSPanel;
